export const QUERY_KEYS = {
	getStudentExams: 'getStudentExams',
	getExpertRepetitiveSlots: 'getExpertRepetitiveSlots',
	countExpertRepetitiveSlotDayByDay: 'countExpertRepetitiveSlotDayByDay',
	getExpertStudents: 'getExpertStudents',
	getLoggedInExpertGroups: 'getLoggedInExpertGroups',
	getLoggedInExpertEvents: 'getLoggedInExpertEvents',
	getSelectableEventTypes: 'getSelectableEventTypes',
	getAcademicBoardExperts: 'getAcademicBoardExperts',
	getAllAppointmentTopics: 'getAllAppointmentTopics',
	findAvailableExpertDailySlots: 'findAvailableExpertDailySlots',
	getAppointmentCancellationCount: 'getAppointmentCancellationCount',
	findAppointmentsOfTheDay: 'findAppointmentsOfTheDay',
	findNearestAvailableSlots: 'findNearestAvailableSlots',
	searchAppointments: 'searchAppointments',
	getExpertPayment: 'getExpertPayment',
	getLoggedInExpertApplicantDetgetStudentExamsilInfo: 'getLoggedInExpertApplicantDetailInfo',
	getDocumentsByContentType: 'getDocumentsByContentType',
	getLiveServiceTypes: 'getLiveServiceTypes',
	getEducationLevels: 'getEducationLevels',
	getApplicationStepProgress: 'getApplicationStepProgress',
	getBranchesByEducationLevel: 'getBranchesByEducationLevel',
	getAllDistricts: 'getAllDistricts',
	getAllCities: 'getAllCities',
	getAllUniversities: 'getAllUniversities',
	getAllGraduatePrograms: 'getAllGraduatePrograms',
	getDocumentTypes: 'getDocumentTypes',
	getLoggedInExpertDetailInfo: 'getLoggedInExpertDetailInfo',
	getAllInteractionConnectionStatusOptions: 'getAllInteractionConnectionStatusOptions',
	findAvailableExpertCalendarSlotsOfDay: 'findAvailableExpertCalendarSlotsOfDay',
	findAssessmentTypes: 'findAssessmentTypes',
	countExpertCalendarSlotAppointmentBetweenDates: 'countExpertCalendarSlotAppointmentBetweenDates',
	getExpertActiveSlotCount: 'getExpertActiveSlotCount',
	isSlotActivatedForToday: 'isSlotActivatedForToday',
	getStudentInteractionFeedback: 'getStudentInteractionFeedback',
	findKyExpertInteractionFeedbackByInteractionId: 'findKyExpertInteractionFeedbackByInteractionId',
	getExpertSettings: 'getExpertSettings',
	getExpertAverageRating: 'getExpertAverageRating',
	findGotItExpertInteractionFeedbackByInteractionId: 'findGotItExpertInteractionFeedbackByInteractionId',
	getMeetingRoomInformation: 'getMeetingRoomInformation',
	findExpertInteractions: 'findExpertInteractions',
	findInteractionsByStudentId: 'findInteractionsByStudentId',
	findStudentExpertChats: 'findStudentExpertChats',
	findStudentExpertChatMessages: 'findStudentExpertChatMessages',
	findStudentExpertChatsWithPage: 'findStudentExpertChatsWithPage',
	findStudentStatisticsOfLoggedInExpert: 'findStudentStatisticsOfLoggedInExpert',
	findContract: 'findContract',
	findContractApplicant: 'findContractApplicant',
	getAllMenuItems: 'getAllMenuItems',
	getActiveMeeting: 'getActiveMeeting',
	findAllChats: 'findAllChats',
	getSupervisorOfLoggedInExpert: 'getSupervisorOfLoggedInExpert',
	findChatMessages: 'findChatMessages',
	findAllTopics: 'findAllTopics',
	branchOptionsCache: 'branchOptionsCache',
	findAppointmentRestrictionOfStudent: 'findAppointmentRestrictionOfStudent',
	findInteractionById: 'findInteractionById',
	findInteractionCommentsById: 'findInteractionCommentsById',
	findExpertUnreadChatCount: 'findExpertUnreadChatCount',
	getExpertQuestionPool: 'getExpertQuestionPool',
	getRemainingPassedQuestionCount: 'getRemainingPassedQuestionCount',
	getExpertSolvedQuestions: 'getExpertSolvedQuestions',
	getUploadUrl: 'getUploadUrl',
	solverPassQuestion: 'solverPassQuestion',
	getStudentContentStatistics: 'getStudentContentStatistics',
	getStudentItemStatistics: 'getStudentItemStatistics',
	getAvailableFilters: 'getAvailableFilters',
	getStudentCurriculumMeasurement: 'getStudentCurriculumMeasurement',
	getStudentCurriculumUnitsMeasurement: 'getStudentCurriculumUnitsMeasurement',
	getStudentCurriculumTopicsMeasurement: 'getStudentCurriculumTopicsMeasurement',
	getAllReportReasons: 'getAllReportReasons',
	searchAvailableHours: 'searchAvailableHours',
	getSlotLimit: 'getSlotLimit',
	getNotificationsByExpertId: 'getNotificationsByExpertId',
	getExpertNotificationUnreadCount: 'getExpertNotificationUnreadCount',
	setExpertNotificationsAsRead: 'setExpertNotificationsAsRead',
	findAppointmentTopics: 'findAppointmentTopics',
	findLessonAppointmentSubjects: 'findLessonAppointmentSubjects',
	findAppointmentSubjects: 'findAppointmentSubjects',
	getMeetingSubjects: 'getMeetingSubjects',
	getExpertCounterpartCountLookingForMatch: 'getExpertCounterpartCountLookingForMatch',
	findExternalReportIssueOptions: 'findExternalReportIssueOptions',
	getInteractionLabels: 'getInteractionLabels',
	findCoachExpertInteractionFeedbackByInteractionId: 'findCoachExpertInteractionFeedbackByInteractionId',
	findExpertParentChatMessages: 'findExpertParentChatMessages',
	findExpertParentChats: 'findExpertParentChats',
	findUnreadSupportMessageCount: 'findUnreadSupportMessageCount',
	findStudentDetailedStatisticsOfLoggedInExpert: 'findStudentDetailedStatisticsOfLoggedInExpert',
	getCompetencies: 'getCompetencies',
	getStudentMissions: 'getStudentMissions',
	getStudentMissionDetail: 'getStudentMissionDetail',
	findProviderFeedbacks: 'findProviderFeedbacks',
	findStudentPackageByStudentId: 'findStudentPackageByStudentId',
	findStudentCreditInformation: 'findStudentCreditInformation',
	getSupportTickets: 'getSupportTickets',
	getSupportTicketMessages: 'getSupportTicketMessages',
	getSupportTicketCategories: 'getSupportTicketCategories',
	getSupportTicketSubCategories: 'getSupportTicketSubCategories',
	findExamTypeByGrade: 'findExamTypeByGrade',
	getReviewsByExpertId: 'getReviewsByExpertId',
	getExpertBranches: 'getExpertBranches',
	findActiveOriginalQuestionIds: 'findActiveOriginalQuestionIds',
	listResolveQuestions: 'listResolveQuestions',
	findSupportDocuments: 'findSupportDocuments',
	getMissionTemplates: 'getMissionTemplates',
	getExpertReviewReasons: 'getExpertReviewReasons',
	findExamStatsByLessons: 'findExamStatsByLessons',
	findExamItemTopics: 'findExamItemTopics'
};
